export default {"src":"/_next/static/media/samewerking.83a0b3fb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};